import { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import { useSelector, useDispatch } from 'react-redux'
import { useCart } from 'lib/core/hooks'
import { getIsLoggedIn } from 'lib/core/data/auth/session/selectors'
import { getOrderId } from 'lib/core/data/quote/placeOrderNext/selectors'
import { getOrderId as getOrderIdRest } from 'lib/core/data/quote/placeOrder/selectors'
import { fetchCustomerCartId } from 'lib/core/data/customer/cartId'
import { fetchCartId as fetchGuestCartId } from 'lib/core/data/quote/cartId'
import { fetchPaymentTokens } from 'lib/core/data/customer/paymentTokens'
import { me } from 'lib/core/data/customer/me'

export const useCheckoutSuccess = () => {
  const dispatch = useDispatch()
  const isLoggedIn = useSelector(getIsLoggedIn)
  const { cartId, cart } = useCart()
  const orderIdGraphQL = useSelector(getOrderId(cartId))
  const orderIdRest = useSelector(getOrderIdRest(cartId))
  const orderId = orderIdGraphQL ?? orderIdRest
  const { email, shippingAddress } = cart?.data ?? {}
  const { phoneNumber, firstName, lastName, street, city, regionLabel, postalCode, countryCode } = shippingAddress ?? {}

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'Conversion',
        email,
        phone_number: phoneNumber,
        first_name: firstName,
        last_name: lastName,
        home_address: {
          street,
          city,
          region: regionLabel,
          postal_code: postalCode,
          country: countryCode
        }
      }
    })

    return () => {
      if (isLoggedIn) {
        dispatch(me())
        dispatch(fetchCustomerCartId())
        dispatch(fetchPaymentTokens())
      } else {
        dispatch(fetchGuestCartId(true))
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isLoggedIn])

  return {
    orderId
  }
}
